import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import IntegrationEquipmentSync from '../IntegrationEquipmentSync';

const autoImportContent = (
  <div style={{ width: 500 }}>
    Ontraccr can automatically import Equipment from Sage Intacct Fixed Assets.
    <br />
    <br />
    1. Equipment records from Sage Intacct will be synced to Ontraccr.
    <br />
    <br />
    2. Equipment Name from Sage Intacct will be used as the Ontraccr Equipment Name.
    <br />
    <br />
    3. The Ontraccr ID will sync to Sage Intacct Serial number.
    <br />
    <br />
    4. The Ontraccr Division will sync to Sage Intacct Location.
    <br />
    <br />
    If you would rather see exactly which
    data will be imported from Sage Intacct
    and fill in any missing fields, disable Auto Import to do this manually.
  </div>
);

const importHelpText = (
  <div style={{ width: 500 }}>
    Select from this dropdown to either
    {' '}
    <b>Import</b>
    {' '}
    new Equipment from Sage Intacct
    or
    {' '}
    <b>Link</b>
    {' '}
    Sage Intacct Equipment to existing Ontraccr Equipment
    <br />
    <br />
    {' '}
    <b>Import:</b>
    {' '}
    Equipment must have a name to be imported into Ontraccr.
    <br />
    {' '}
    <b>Link:</b>
    {' '}
    Select an existing Ontraccr equipment to link with the Sage Intacct Equipment.
  </div>
);

function SageIntacctEquipmentSync({
  sageIntacctEquipment = [],
  onEquipmentChanged,
  importEquipment,
  divisionFilter,
}) {
  return (
    <IntegrationEquipmentSync
      title="Sage Intacct"
      integrationEquipment={sageIntacctEquipment}
      integrationKey="sageId"
      onEquipmentChanged={onEquipmentChanged}
      autoImportContent={autoImportContent}
      importHelpText={importHelpText}
      importEquipment={importEquipment}
      divisionFilter={divisionFilter}
    />
  );
}

/* eslint-disable  react/forbid-prop-types */
SageIntacctEquipmentSync.propTypes = {
  sageIntacctEquipment: PropTypes.array,
  onEquipmentChanged: PropTypes.func.isRequired,
  importEquipment: PropTypes.array,
  divisionFilter: PropTypes.instanceOf(Set),
};

SageIntacctEquipmentSync.defaultProps = {
  sageIntacctEquipment: [],
  importEquipment: [],
  divisionFilter: null,
};

export default SageIntacctEquipmentSync;
